module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Arrows-9357a90e5850c48dea101a729da78a66.svg";